import { User, FileText, Briefcase, Files, FolderOpen, HomeIcon } from "lucide-react";

export const navigationItems = [
  { key: "nav.home", icon: HomeIcon, href: "/" },
  { key: "nav.me", icon: User, href: "/me" },
  { key: "nav.attendance", icon: Briefcase, href: "/attendance" },
  { key: "nav.my_tasks", icon: FolderOpen, href: "/tasks" },
  { key: "nav.documents", icon: Files, href: "/documents" },
  { key: "nav.services", icon: Briefcase, href: "/services" },
  { key: "nav.requests", icon: FileText, href: "/requests" },
];
